import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { ProgressBar as u, Intent as h } from "@blueprintjs/core";
import { addCommas as i } from "@strata/helper-functions";
import { DollarAmount as l } from "@strata/react-dollar-amount";
import "./main.scss";
const b = ({
  completed: s,
  total: e,
  labelText: a = void 0,
  dollarSign: n = !1,
  animate: t = !1,
  stripes: d = !1
}) => {
  const m = s / e;
  return /* @__PURE__ */ o("div", { className: "sds_progress-bar", children: [
    a && /* @__PURE__ */ o("div", { className: "sds_progress-bar__label", children: [
      n ? /* @__PURE__ */ r(
        l,
        {
          amount: s,
          showZeroValue: !0,
          hideCents: !0,
          large: !0,
          style: { display: "inline-block" }
        }
      ) : /* @__PURE__ */ r("span", { children: i(s) }),
      /* @__PURE__ */ r("span", { children: " of " }),
      n ? /* @__PURE__ */ r(
        l,
        {
          amount: e,
          showZeroValue: !0,
          hideCents: !0,
          large: !0,
          style: { display: "inline-block" }
        }
      ) : /* @__PURE__ */ r("span", { children: i(s) }),
      /* @__PURE__ */ r("span", { children: ` ${a}` })
    ] }),
    /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r(
      u,
      {
        value: m,
        intent: h.PRIMARY,
        animate: t,
        stripes: d
      }
    ) })
  ] });
};
export {
  b as ProgressBar
};
//# sourceMappingURL=index.js.map
